// Nosh catering menu — transcribed exactly from the printed menu.
export const MENU = [
  {
    id: "appetizer",
    title: "Appetizer",
    tagline: "Where every feast begins",
    items: [
      { name: "Russian Salad", half: 55, full: 80 },
      { name: "Dahi Bhallay", half: 40, full: 55 },
    ],
  },
  {
    id: "rice",
    title: "Rice",
    tagline: "Long-grain, slow-layered, saffron-kissed",
    items: [
      { name: "Chicken Biryani", half: 70, full: 130 },
      { name: "Chicken Pilau", half: 70, full: 130 },
      { name: "Beef Biryani", half: 80, full: 150 },
      { name: "Goat Biryani", half: 90, full: 160 },
      { name: "Goat Pilau", half: 90, full: 160 },
      { name: "Channay Wale Rice", half: 50, full: 70 },
      { name: "Singaporean Rice", half: 60, full: 110 },
    ],
  },
  {
    id: "chicken",
    title: "Chicken Corner",
    tagline: "Home-style, bone-in, full of soul",
    items: [
      { name: "Chicken Korma", half: 70, full: 120 },
      { name: "Chicken Karahi", half: 80, full: 130 },
      { name: "Palak Chicken", half: 60, full: 120 },
    ],
  },
  {
    id: "goat",
    title: "Goat Corner",
    tagline: "Slow-cooked till it falls off the bone",
    items: [
      { name: "Goat Korma", half: 90, full: 170 },
      { name: "Goat Karahi", half: 100, full: 190 },
      { name: "Palak Gosht", half: 80, full: 160 },
      { name: "Goat Nihari", half: 90, full: 170 },
    ],
  },
  {
    id: "veggie",
    title: "Veggie Corner",
    tagline: "Daal, channay & everything comforting",
    items: [
      { name: "Lahori Channay", half: 60, full: 110 },
      { name: "Daal Makni", half: 40, full: 70 },
      { name: "Fry Daal Mash", half: 60, full: 110 },
    ],
  },
  {
    id: "pasta",
    title: "Pasta / Noodles",
    tagline: "Desi hands, global flavours",
    items: [
      { name: "Baked Ziti", half: 60, full: 90 },
      { name: "Alfredo Pasta", note: "Veggies, Chicken Optional", half: 60, full: 90 },
      { name: "Hakka Noodles", note: "Chicken + Veggies", half: 70, full: 130 },
    ],
  },
  {
    id: "dessert",
    title: "Dessert",
    tagline: "The sweet last word",
    items: [
      { name: "Zarda Rice", note: "Full loaded with nuts", half: 100, full: 200 },
    ],
  },
];

// Flat list for the tray builder
export const ALL_DISHES = MENU.flatMap((section) =>
  section.items.map((item) => ({ ...item, section: section.title, sectionId: section.id }))
);
